export const Size = {
  INPUT_HEIGHT: 2.2, // rem
};

export const PortalData = {
  MINIMUM_MONTHLY_AMOUNT: 0, //250,
};
